import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { ZagIcon } from '../icon/icon';

export type LoadStatus = 'loading' | 'error' | 'ready';

@Component({
  selector: 'zag-loading-state',
  imports: [ZagIcon],
  template: `
    <div class="loading-state">
      <span zagIcon="sync" class="loading-state__spinner spinning"></span>
      <p class="loading-state__message">{{ message() }}</p>
    </div>
  `,
  styleUrl: './loading-state.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoadingStateComponent {
  readonly message = input<string>('Loading...');
}
